export class UnknownFieldTypeError extends Error implements Error {
  public name = 'UnknownFieldTypeError';
}
